/**
 * Das Hilfe-Popover: die Gesten auf der Zeichenfläche, die kein Editor von sich aus zeigt.
 *
 * Die Tastenkürzel stehen nicht hier — ein Kürzel bringt seine Beschriftung von der
 * Stelle mit, an der es gebunden wird.
 *
 * Welcher Editor welche Einträge zeigt, entscheidet utils/_shared/editorHelp.ts.
 */

export default {
	help: {
		title: "Tastatur und Leinwand",
		shortcuts: "Tastenkürzel",
		canvas: "Leinwand",
		panels: "Seitenleisten",
		gestures: {
			// ── Informationsmodell ──
			dataobjectDrag: {
				gesture: "Aus der Liste ziehen",
				effect: "Fügt das Datenobjekt dort in die Ansicht ein, wo es abgelegt wird.",
			},
			modelCanvasDoubleClick: {
				gesture: "Doppelklick auf die Leinwand",
				effect: "Fügt ein vorhandenes Datenobjekt ein oder legt unter dem eingegebenen Namen ein neues an.",
			},
			modelNodeDoubleClick: {
				gesture: "Doppelklick auf einen Knoten",
				effect: "Öffnet seine Beziehungen in der Eigenschaftsleiste.",
			},
			modelAltDrag: {
				gesture: "{key} + einen Knoten auf einen anderen ziehen",
				effect: "Legt eine Beziehung vom Ausgangsknoten zum Zielknoten an.",
			},
			modelTypeAltClick: {
				gesture: "{key} + Klick auf den Datentyp eines Attributs",
				effect: "Öffnet diesen Datentyp auf der Seite Datentypen.",
			},
			modelLinkClick: {
				gesture: "Klick auf eine Beziehungslinie",
				effect: "Löscht diese Beziehung nach Rückfrage.",
			},
			modelNodeContextMenu: {
				gesture: "Rechtsklick auf einen Knoten",
				effect: "Öffnet ein Menü: aus der Ansicht entfernen oder das Datenobjekt ganz löschen.",
			},

			// ── Prozess ──
			pdoDrag: {
				gesture: "Aus der Übersicht ziehen",
				effect: "Fügt ein Wurzel-Datenobjekt ein. Wird dasselbe erneut gezogen, entsteht eine zweite Kopie.",
			},
			processCanvasDoubleClick: {
				gesture: "Doppelklick auf die Leinwand",
				effect: "Fügt an dieser Stelle ein Wurzel-Datenobjekt ein.",
			},
			processNodeDoubleClick: {
				gesture: "Doppelklick auf einen Knoten",
				effect: "Öffnet seine Beziehungen in der Eigenschaftsleiste.",
			},
			processAltDrag: {
				gesture: "{key} + einen Knoten auf einen anderen ziehen",
				effect: "Hängt den Zielknoten unter den Ausgangsknoten — und löst ihn aus seiner bisherigen Beziehung.",
			},
			processNodeContextMenu: {
				gesture: "Rechtsklick auf einen Knoten",
				effect: "Öffnet ein Menü. Das Entfernen von dort nimmt alles mit, was unter dem Knoten hängt.",
			},

			// ── Aktivität ──
			actionDrag: {
				gesture: "Aus der Palette ziehen",
				effect: "Fügt die Aktion dort ein, wo sie abgelegt wird.",
			},
			actionConnect: {
				gesture: "Von Punkt zu Punkt ziehen",
				effect: "Verbindet die Aktionen. Punkte, die die Verbindung nicht annehmen können, werden ausgegraut.",
			},
			edgeClick: {
				gesture: "Klick auf eine Verbindung",
				effect: "Bietet an, sie zu entfernen — direkt an der angeklickten Stelle.",
			},
			actionCanvasDoubleClick: {
				gesture: "Doppelklick auf die Leinwand",
				effect: "Öffnet eine Suche, um eine Aktion aus einer anderen Aktivität hierher zu kopieren.",
			},
			actionContextMenu: {
				gesture: "Rechtsklick auf eine Aktion",
				effect: "Öffnet ein Menü: bearbeiten, duplizieren, umfärben oder löschen.",
			},

			// ── Übergreifend ──
			stickyTab: {
				gesture: "Knoten nach Knoten anklicken",
				effect: "Der geöffnete Tab bleibt offen, sodass sich dieselbe Facette vergleichen lässt.",
			},
			panelResize: {
				gesture: "Innere Kante einer Seitenleiste ziehen",
				effect: "Ändert ihre Breite. Die Breite bleibt für das nächste Mal erhalten.",
			},
		},
	},
};
